export const siteInfo = {
  name: '爆料短剧',
  slogan: '按顺序追剧，不漏更、不乱序',
  intro:
    '爆料短剧是一份面向短剧观众的更新追踪表。我们把每一部在追的短剧都按连续剧集更新顺序排好，配上追剧日历、剧情分集介绍、下一集预告与全季剧情梗概，让你打开一个页面就知道「今天更新到哪儿、上一集讲了什么、下一集会发生什么」。',
  email: 'hello@baoliao-duanju.example.com',
  since: '2024',
  updatedAt: '2026-09-10',
};

export const categories = [
  { key: '都市逆袭', desc: '重生、回归、打脸升级', count: 2, icon: 'ri-building-2-line' },
  { key: '古装剧场', desc: '权谋、宅斗、女性群像', count: 2, icon: 'ri-ancient-pavilion-line' },
  { key: '甜宠恋爱', desc: '暗恋、久别、双向奔赴', count: 1, icon: 'ri-heart-3-line' },
  { key: '悬疑推理', desc: '迷雾、旧案、抽丝剥茧', count: 1, icon: 'ri-foggy-line' },
  { key: '奇幻轻喜', desc: '变身、治愈、办公室日常', count: 1, icon: 'ri-magic-line' },
  { key: '家庭情感', desc: '现实、群像、慢火细熬', count: 1, icon: 'ri-home-heart-line' },
];

export const stats = [
  { value: '8', unit: '部', label: '在追短剧' },
  { value: '486', unit: '集', label: '已整理分集' },
  { value: '7', unit: '天', label: '追剧日历覆盖' },
  { value: '100', unit: '%', label: '集数顺序可核对' },
];

export const principles = [
  {
    icon: 'ri-sort-asc',
    title: '先排序，再开聊',
    desc: '每部剧都先按连续剧集更新顺序整理清楚，标注更新日期与集数区间，避免看错集、跳着看。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '日历跟着平台走',
    desc: '追剧日历只记录官方公布的更新节奏，平台调整时我们同步修订，不猜、不编、不抢先。',
  },
  {
    icon: 'ri-file-text-line',
    title: '分集介绍有分寸',
    desc: '剧情分集介绍写清楚这一集发生了什么，但会避开关键反转的完整剧透，把悬念留给你自己。',
  },
  {
    icon: 'ri-refresh-line',
    title: '预告与梗概持续更新',
    desc: '下一集预告一旦公布就补上，全季剧情梗概随更新推进持续修订，越追越完整。',
  },
];

export const testimonials = [
  {
    name: '林小满',
    role: '通勤追剧党',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20soft%20portrait%20of%20a%20cheerful%20young%20Chinese%20woman%20with%20short%20hair%2C%20cream%20background%2C%20gentle%20natural%20window%20light%2C%20clean%20editorial%20style%2C%20high%20detail&width=200&height=200&seq=duanju-avatar-01&orientation=squarish',
    text: '以前追短剧最怕乱序，这部剧到底更到第几集全靠自己数。现在打开追剧日历一眼就清楚，晚上几点更新也写得明明白白。',
  },
  {
    name: '周叙',
    role: '剧情考据爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20soft%20portrait%20of%20a%20calm%20young%20Chinese%20man%20wearing%20glasses%2C%20cream%20background%2C%20gentle%20natural%20light%2C%20clean%20editorial%20style%2C%20high%20detail&width=200&height=200&seq=duanju-avatar-02&orientation=squarish',
    text: '我最看重的是分集介绍写得克制，关键反转不会被提前写死。前一集忘了剧情，翻一下梗概就能接上，不用重看。',
  },
  {
    name: '阿棠',
    role: '短剧十级观众',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20soft%20portrait%20of%20a%20smiling%20young%20Chinese%20woman%20with%20long%20wavy%20hair%2C%20cream%20background%2C%20gentle%20natural%20light%2C%20clean%20editorial%20style%2C%20high%20detail&width=200&height=200&seq=duanju-avatar-03&orientation=squarish',
    text: '全季剧情梗概真的省事，一口气拉到底就能回忆起整条主线。加上下一集预告，每天等更新的期待感都变强了。',
  },
];

export const faqs = [
  {
    q: '爆料短剧的「连续剧集更新顺序」是怎么整理的？',
    a: '我们以平台官方公布的更新节奏为准，把每一集的集号、更新的日期和所属的集数区间逐条记录，再按时间先后排成一条更新顺序线。你打开对应剧集详情页，就能看到从已更新到下一集预告的完整顺序。',
  },
  {
    q: '追剧日历和平台实际的更新时间会不一致吗？',
    a: '追剧日历会跟随平台的官方节奏同步。如果平台临时调整档期、加更或停更，我们会在更新后修订日历，并在对应剧集页面标注变化，尽量减少你白等的情况。',
  },
  {
    q: '剧情分集介绍会剧透关键反转吗？',
    a: '不会。分集介绍只交代这一集主要的剧情走向和人物动作，对核心反转会做留白处理，把悬念保留给正片。如果你只想快速回忆剧情，看全季剧情梗概更合适。',
  },
  {
    q: '下一集预告一般什么时候更新？',
    a: '官方放出预告后我们会尽快整理进剧集详情页，通常在该集正式更新前一到两天上线。预告包含集号、上线日期与剧情走向提示。',
  },
  {
    q: '已完结的短剧还能查到全季剧情梗概吗？',
    a: '可以。已完结剧集的全季剧情梗概会做一次完整梳理，分集介绍与集数顺序也会保留，方便你补剧时按顺序查看，不用担心遗漏。',
  },
  {
    q: '我可以推荐想追的短剧吗？',
    a: '当然可以。你可以通过「关于我们」页面的联系方式把剧名和平台发给我们，我们会评估更新节奏是否稳定，并把适合的剧集加入追踪列表。',
  },
];

export const aboutValues = [
  { title: '定位', desc: '做一份干净的更新追踪表，而不是堆满弹窗的聚合页。' },
  { title: '读者', desc: '为碎片时间追剧、又不想漏掉任何一集的观众而写。' },
  { title: '原则', desc: '只写看得见的更新，不编造未公布的剧情和档期。' },
  { title: '更新', desc: '跟随平台节奏持续修订日历、分集介绍与全季梗概。' },
];